module.exports = __webpack_public_path__ + "static/img/ri-knife-line.ee0f7c53.svg";